import CatalogAPI from '../../api/whatsapp/catalog';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  catalogs: [],
  catalogConfigured: false,
  discoveryError: '',
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getProducts(_state) {
    return _state.records;
  },
  getCatalogs(_state) {
    return _state.catalogs;
  },
  isCatalogConfigured(_state) {
    return _state.catalogConfigured;
  },
  getDiscoveryError(_state) {
    return _state.discoveryError;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function get({ commit }, inboxId) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await CatalogAPI.getProducts(inboxId);
      commit('SET_CONFIGURED', response.data.catalog_configured);
      commit('SET_PRODUCTS', response.data.products || []);
      commit('SET_CATALOGS', response.data.catalogs || []);
      commit('SET_DISCOVERY_ERROR', response.data.discovery_error || '');
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async function create({ commit }, { inboxId, product }) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await CatalogAPI.createProduct({ inboxId, product });
      commit('ADD_PRODUCT', response.data.product);
      return response.data.product;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async function update({ commit }, { inboxId, id, product }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await CatalogAPI.updateProduct({ inboxId, id, product });
      commit('UPDATE_PRODUCT', { id, product: response.data.product });
      return response.data.product;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async function deleteProduct({ commit }, { inboxId, id }) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await CatalogAPI.deleteProduct({ inboxId, id });
      commit('DELETE_PRODUCT', id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  listCatalogs: async function listCatalogs({ commit }, inboxId) {
    try {
      const response = await CatalogAPI.listCatalogs(inboxId);
      commit('SET_CATALOGS', response.data.catalogs || []);
    } catch (error) {
      throwErrorMessage(error);
    }
  },

  setCatalogId: async function setCatalogId(
    { dispatch },
    { inboxId, catalogId }
  ) {
    try {
      await CatalogAPI.setCatalogId({ inboxId, catalogId });
      await dispatch('get', inboxId);
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  SET_CONFIGURED(_state, value) {
    _state.catalogConfigured = value;
  },
  SET_PRODUCTS(_state, products) {
    _state.records = products;
  },
  SET_CATALOGS(_state, catalogs) {
    _state.catalogs = catalogs;
  },
  SET_DISCOVERY_ERROR(_state, error) {
    _state.discoveryError = error;
  },
  ADD_PRODUCT(_state, product) {
    if (product) _state.records.push(product);
  },
  UPDATE_PRODUCT(_state, { id, product }) {
    const index = _state.records.findIndex(record => record.id === id);
    if (index !== -1 && product) _state.records.splice(index, 1, product);
  },
  DELETE_PRODUCT(_state, id) {
    _state.records = _state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
